import mixpanel from 'mixpanel-browser';

mixpanel.init("cc672a129b002bb11ac43ed06b0e0a12", {track_pageview: true, debug:true});

const MIXPANEL = {
  track: (event: string, data?: any) => {
    mixpanel.track(event, data);
  },
  default: mixpanel
};
export { MIXPANEL };
